// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userSetupHeaderStyles } from "@awc/Overrides/Widgets/UserSetup/UserSetupHeader";
import { color, xScreen } from "@awc/XDL/Utilities";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

userSetupHeaderStyles.container = {
    css: css`
        padding-bottom: 15px;
    `,
};

userSetupHeaderStyles.actionsGridItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "sm")} {
            flex-basis: 100%;
            ma-width: 100%;
        }
        padding-top: 21px;
        flex-direction: column;
    `,
};

userSetupHeaderStyles.returnLinkGridItem = {
    width: 12,
    css: css`
        justify-content: end;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

userSetupHeaderStyles.returnButton = {
    variant: "secondary",
};

userSetupHeaderStyles.assignShipToAddressButton = {
    variant: "secondary",
    css: css`
        margin-bottom: 24px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

userSetupHeaderStyles.saveButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

userSetupHeaderStyles.cancelButton = {
    variant: "primary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

userSetupHeaderStyles.actionsWrapper = {
    css: css`
        display: flex;
        gap: 10px;
        justify-content: end;
        width: 100%;
        ${xScreen("lte", "sm")} {
            gap: 16px;
            flex-direction: column;
        }
    `,
};

userSetupHeaderStyles.titleGridItem = {
    width: 12
}
